import { z } from 'zod';
import type { Currency } from '@repo/shared/types';
import { moneySchema } from '@repo/shared/types';
import { loanEditRequestBodySchema } from '@repo/api/endpoints/loan';

export const AgreementAndApprovalsSchema = z
  .object({
    editedAmount: moneySchema,
    originalAmount: moneySchema,
  })
  .and(loanEditRequestBodySchema.omit({ data: true }));

export type AgreementAndApprovalsFields = z.infer<typeof AgreementAndApprovalsSchema>;

export interface AgreementAndApprovalsDetails {
  repayment: number;
  period: number;
  payoff: number;
  currency: Currency;
  pricing: number;
}

export interface AdvancePaymentDetails {
  min: number;
  max: number;
}
